import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star, Check, AlertTriangle } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42828918915143:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42828921372743:1';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 px-4 max-w-6xl mx-auto scroll-mt-16" data-id="element-314">
      {/* COUNTDOWN BLOCK */}
      <div className="text-center mb-12 md:mb-16" data-id="element-315">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-316">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-2xl mx-auto" data-id="element-317">
          Asegurá el precio promocional{' '}
          <span className="text-primary" data-id="element-318">antes de que suba.</span>
        </h2>

        <div className="mb-6" data-id="element-319">
          <Countdown data-id="element-320" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-2xl mx-auto" data-id="element-321">
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-322">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-323" /> Después sube
            y no vuelve a bajar
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-324">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-325" /> 78% de cupos
            tomados
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-326">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-327" /> Esta promo
            no vuelve
          </div>
        </div>
      </div>

      {/* OFFER */}
      <div className="text-center mb-10 md:mb-12" data-id="element-328">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-329">
          💳 Elegí tu plan
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold mb-3 leading-tight" data-id="element-330">
          Empezá tu transformación{' '}
          <span className="text-primary" data-id="element-331">hoy mismo</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-332">
        {/* OPTION 1 — COMBO COMPLETO HIIT PRO */}
        <div className="bg-surface border border-zinc-800 rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-333">
          <div className="mb-5" data-id="element-334">
            <div className="flex items-center gap-2 mb-2" data-id="element-335">
              <span className="text-3xl md:text-4xl" data-id="element-336">🍑</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-337">
                30 Días de Glúteos
              </h3>
            </div>
            <p className="text-zinc-400 text-sm" data-id="element-338">4 Tomos + Bono Recetario</p>
          </div>

          <div className="bg-surface2 border border-zinc-800/60 p-4 rounded-xl mb-6 text-sm text-zinc-300 leading-relaxed" data-id="element-339">
            <span className="font-bold text-white" data-id="element-340">Ideal para:</span> La mujer
            que quiere el plan completo y las recetas para empezar hoy.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-341">
            {['Tomo 1: Despertar Glúteo', 'Tomo 2: Construcción de Masa', 'Tomo 3: Efecto Cintura', 'Tomo 4: Los 30 Días completos', 'Bono: Recetario 30 días Argentina', 'Acceso inmediato (5 minutos)', 'Garantía 7 días sin preguntas'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-342">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-343" />
                <span className="text-zinc-200" data-id="element-344">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-345">
            <div className="text-zinc-500 line-through text-base font-bold mb-1" data-id="element-346">
              Antes: $51.900
            </div>
            <div className="text-xs text-zinc-400 mb-1 uppercase tracking-wide font-bold" data-id="element-347">
              Hoy
            </div>
            <div className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-348">
              $19.990{' '}
              <span className="text-xl md:text-2xl text-zinc-400" data-id="element-349">ARS</span>
            </div>
          </div>

          <Button href={URL_COMBO} fullWidth className="py-4 text-base md:text-lg" data-id="element-350">
            👉 QUIERO MIS 4 TOMOS AHORA
          </Button>
        </div>

        {/* OPTION 2 — COMBO + TURNOS LLENOS (RECOMMENDED) */}
        <div className="relative bg-surface border-2 border-primary rounded-3xl p-6 md:p-8 flex flex-col shadow-[0_0_50px_rgba(249,168,212,0.18)] transform md:-translate-y-2" data-id="element-351">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-black font-extrabold px-4 py-1 rounded-full text-xs md:text-sm flex items-center gap-1 whitespace-nowrap shadow-[0_0_15px_rgba(249,168,212,0.6)]" data-id="element-352">
            <Star className="w-3.5 h-3.5 fill-black" data-id="element-353" /> MÁS ELEGIDO
          </div>

          <div className="mb-5" data-id="element-354">
            <div className="flex items-center gap-2 mb-2" data-id="element-355">
              <span className="text-3xl md:text-4xl" data-id="element-356">🔥</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-357">Plan Total</h3>
            </div>
            <p className="text-primary text-sm font-medium" data-id="element-358">
              4 Tomos +Bono+ PROTOCOLO 360
            </p>
          </div>

          <div className="bg-primary/10 border border-primary/30 p-4 rounded-xl mb-6 text-sm text-zinc-200 leading-relaxed" data-id="element-359">
            <span className="font-bold text-white" data-id="element-360">Ideal para:</span> La mujer
            que quiere asegurarse de medir y ver su progreso real.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-361">
            {['TODO el plan base incluido', 'Guía express de medición y fotos comparativas', 'Checklist maestra de los 30 días imprimible', 'Tracker semanal de cargas y progreso', 'Protocolo Plan B para días sin tiempo', 'Guía de qué hacer después del día 30'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-362">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-363" />
                <span className="text-white font-medium" data-id="element-364">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-365">
            <div className="text-zinc-500 line-through text-base font-bold mb-1" data-id="element-366">
              Antes: $76.900
            </div>
            <div className="text-xs text-primary mb-1 uppercase tracking-wide font-bold" data-id="element-367">
              Hoy
            </div>
            <div className="text-4xl md:text-5xl font-extrabold text-primary" data-id="element-368">
              $27.990{' '}
              <span className="text-xl md:text-2xl text-zinc-400" data-id="element-369">ARS</span>
            </div>
          </div>

          <Button href={URL_NEGOCIO} fullWidth className="py-4 text-base md:text-lg shadow-[0_0_25px_rgba(249,168,212,0.4)]" data-id="element-370">
            👉 QUIERO EL PLAN TOTAL
          </Button>
        </div>
      </div>

      <p className="text-center text-xs md:text-sm text-zinc-400 mt-8" data-id="element-371">
        🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 💳 Mercado Pago hasta 12
        cuotas
      </p>
    </section>;
}